module.exports = __webpack_public_path__ + "img/HZ3602-154.2c610ca7.jpg";